export const USER_REGISTER_REQUEST = "USER_REGISTER_REQUEST";
export const USER_REGISTER_SUCCESS = "USER_REGISTER_SUCCESS";
export const USER_REGISTER_FAIL = "USER_REGISTER_FAIL";

export const USER_LOGIN_REQUEST = "USER_LOGIN_REQUEST";
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGIN_FAIL = "USER_LOGIN_FAIL";
export const USER_LOGOUT = "USER_LOGOUT";

export const GET_ORDERED_REQUEST = "GET_ORDERED_REQUEST";
export const GET_ORDERED_SUCCESS = "GET_ORDERED_SUCCESS";
export const GET_ORDERED_FAIL = "GET_ORDERED_FAIL";

export const UPDATE_PROFILE = "UPDATE_PROFILE";
